
import { CommonSearchParam, ApiBind } from './common-search-param.model';

export class PlacementRelationSearchParam extends CommonSearchParam {

  constructor(
    name?: string,
    placementId?: string,
    placementIds?: string[],
    adRequestName?: string,
    mediaTypes?: string,
    deliveryPF?: number,
    hasOnlyBiddingPlatforms?: boolean,
    hasOnlyNetworkPlatforms?: boolean
  ) {
    super();
    this.name = name;
    this.placement_id = placementId;
    this.placement_ids = placementIds;
    this.ad_request_name = adRequestName;
    this.media_type = mediaTypes;
    this.platform_id = deliveryPF;
    this.has_only_bidding_platforms = hasOnlyBiddingPlatforms;
    this.has_only_network_platforms = hasOnlyNetworkPlatforms;
  }

  @ApiBind({ column: 'name' })
  name: string;
  @ApiBind({ column: 'placement_id' })
  placement_id: string;
  @ApiBind({ column: 'placement_ids' })
  placement_ids: string[];
  @ApiBind({ column: 'ad_request_name' })
  ad_request_name: string;
  @ApiBind({ column: 'media_type' })
  media_type: string;
  @ApiBind({ column: 'platform_id' })
  platform_id: number;
  @ApiBind({ column: 'has_only_bidding_platforms' })
  has_only_bidding_platforms: boolean;
  @ApiBind({ column: 'has_only_network_platforms' })
  has_only_network_platforms: boolean;

}
